import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedDeleteSegment } from './DeleteSegment';
import { CMS } from '../../../../utils/CMS';

export const DeleteSegmentMobile = ({ index }) => (
    <ConnectedDeleteSegment
        index={index}
        render={
            ({ onClick, shouldShow }) => (
                <React.Fragment>
                    { shouldShow && (
                        <div
                            className='odf-text-m'
                            onClick={onClick}
                        >
                            <span className='odf-text-md odf-space-outer-right-xs'>
                                <CMS id='flightsManager.delete' />
                            </span>
                            <span className='odf-icon odf-icon-l odf-icon-cross-light' />
                        </div>
                    )}
                </React.Fragment>
            )
        }
    />
);

DeleteSegmentMobile.propTypes = {
    index: PropTypes.number.isRequired,
};
